// studentTableColumns.js
export const getStudentTableColumns = (educationClasses = []) => [
  {
    title: "Name",
    key: "name",
    render: (record) => (
      record.full_name ||
      record.name ||
      `${record.firstName || ""} ${record.lastName || ""}`.trim() ||
      "N/A"
    ),
  },
  {
    title: "Register Date",
    key: "date",
    render: (record) => (
      record.created_at
    ),
  },
  {
    title: "Class",
    dataIndex: "education_class_id",
    key: "education_class_id",
    render: (text, record) => {
      if (text && educationClasses.length > 0) {
        const classItem = educationClasses.find(
          (item) => item.id === text || item.id === parseInt(text)
        );
        if (classItem) {
          return classItem.name;
        }
      }
      
      // Fallback: check if record has education_class property
      if (record.education_class) {
        return record.education_class;
      }
      
      // Additional fallbacks
      if (record.class_name) return record.class_name;
      if (record.class) return record.class;
      
      return "N/A";
    },
    sorter: (a, b) => {
      const getClassName = (record) => {
        if (record.education_class_id && educationClasses.length > 0) {
          const classItem = educationClasses.find(
            (item) => item.id === record.education_class_id
          );
          return classItem ? classItem.name : "";
        }
        return record.education_class || "";
      };
      
      return getClassName(a).localeCompare(getClassName(b));
    },
    filters: Array.from(new Set(educationClasses.map(c => c.name))).map(name => ({
      text: name,
      value: name,
    })),
    onFilter: (value, record) => {
      if (record.education_class_id && educationClasses.length > 0) {
        const classItem = educationClasses.find(
          (item) => item.id === record.education_class_id
        );
        return classItem ? classItem.name === value : false;
      }
      return record.education_class === value;
    },
  },
];